import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.css']
})
export class TimeComponent implements OnInit {

  @Input() value!: string;

  formattedValue!: string;

  constructor() {
  }

  ngOnInit(): void {
    this.formattedValue = this.formatValue();
  }

  formatValue(): string {
    let formatted = '';
    const hours = +this.value.substring(0, 2);
    const minutes = +this.value.substring(3, 5);
    const seconds = +this.value.substring(6, 8);

    if (hours) {
      if (formatted) {
        formatted += ' ';
      }
      formatted += hours + ' ч';
    }

    if (minutes) {
      if (formatted) {
        formatted += ' ';
      }
      formatted += minutes + ' мин';
    }

    if (seconds) {
      if (formatted) {
        formatted += ' ';
      }
      formatted += seconds + ' сек';
    }

    return formatted;
  }

}
